import { revertSimInventoryTableConfiguration } from 'simInventory/SimInventoryApi/simInventoryTableConfigurationApi';
import { TableConfiguration } from 'src/common/components/Sim/Inventory/constants/columnConfigurationsConstants';
import { saveSimInventoryTableConfiguration } from '../../../SimInventoryApi/simInventoryTableConfigurationApi';
import { simInventoryQueries } from 'src/simInventory/Inventory/queries/simInventoryQueries';
import { useConfigurationActions } from 'src/common/components/Sim/Inventory/hooks/useConfigurationActions';

export const useSimProfilesConfigurationActions = (configuration: TableConfiguration) => {
  return useConfigurationActions({
    configuration,
    saveConfiguration: saveSimInventoryTableConfiguration,
    revertConfiguration: revertSimInventoryTableConfiguration,
    refetchQueryKey: simInventoryQueries.all,
  });
};
